const Theme = {
  colors: {
    primary: "#000",
    grey: "#ededed",
    greyDarker: "#636363",
    green: "#31ad20",
    textGrey: "#666",
    linkGrey: "#6d6d6d",
  },
  fonts: {
    primary: "Raleway, sans-serif",
  },
  screen: {
    desktop: 1440,
    narrow: 1024,
    tablet: 768,
    mobile: 415,
    mobileXs: 380,
  },
}

export default Theme
